/**
 * Day code to abbreviation mapping for frequency display
 * Codes match ISO weekday numbers (1 = Monday, 7 = Sunday)
 */
export interface DayItem {
  code: number;
  day: string;
}

export const DAYS_LIST: readonly DayItem[] = [
  { code: 1, day: 'LU' },
  { code: 2, day: 'MA' },
  { code: 3, day: 'MI' },
  { code: 4, day: 'JU' },
  { code: 5, day: 'VI' },
  { code: 6, day: 'SA' },
  { code: 7, day: 'DO' },
] as const;

/**
 * Map for quick day code to abbreviation lookup
 */
export const DAYS_MAP: ReadonlyMap<number, string> = new Map(DAYS_LIST.map((d) => [d.code, d.day]));
